import { render, staticRenderFns } from "./deleteFeeConfig.vue?vue&type=template&id=9f879c30&scoped=true"
import script from "./deleteFeeConfig.vue?vue&type=script&lang=js"
export * from "./deleteFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./deleteFeeConfig.vue?vue&type=style&index=0&id=9f879c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f879c30",
  null
  
)

export default component.exports